const routes = [
  {
    path: '*',
    redirect: '/index'
  },
  {
    name: 'index',
    path: '/index',
    component: (resolve) => require(['./views/index'], resolve)
  },
  {
    name: 'introduction',
    path: '/introduction',
    component: (resolve) => require(['./views/introduction'], resolve)
  },
  {
    name: 'team',
    path: '/team',
    component: (resolve) => require(['./views/team'], resolve)
  },
  {
    name: 'history',
    path: '/history',
    component: (resolve) => require(['./views/history'], resolve)
  }
]

export default routes
